"use strict";
function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;
  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;
      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node,
          offset: offset - nodeStart
        };
      }
      nodeStart = nodeEnd;
    }
    node = getLeafNode(getSiblingNode(node));
  }
}
module.exports = getNodeForCharacterOffset;
